import { Box } from '@mui/material';
import { CustomTextField, DialogTitle, HorizontalForm } from '../../../common';

const LocationDataSection = ({ selectedBranch, onInputChange, isMobile }) => {
  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos de localización
      </DialogTitle>

      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            name="adress"
            label="Dirección"
            value={selectedBranch.adress || ''}
            onChange={onInputChange}
            required
            fullWidth
          />

          <CustomTextField
            name="postal_code"
            label="Código Postal"
            value={selectedBranch.postal_code || ''}
            onChange={onInputChange}
            required
            fullWidth
          />

          <CustomTextField
            name="city"
            label="Ciudad"
            value={selectedBranch.city || ''}
            onChange={onInputChange}
            required
            fullWidth
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomTextField
            name="province"
            label="Provincia"
            value={selectedBranch.province || ''}
            onChange={onInputChange}
            required
            fullWidth
          />

          <CustomTextField
            name="country"
            label="País"
            value={selectedBranch.country || ''}
            onChange={onInputChange}
            required
            fullWidth
          />

          <CustomTextField
            name="gps_cords"
            label="Coordenadas GPS"
            value={selectedBranch.gps_cords || ''}
            onChange={onInputChange}
            fullWidth
          />
        </Box>
      </HorizontalForm>
    </Box>
  );
};

export default LocationDataSection;
